/**
 * Workspace store using Zustand
 * Manages current workspace and profile state globally
 */

import type { ProfileResponse } from '@dovydaskukalis/shared/types/api/profiles/responses';
import type { WorkspaceResponse } from '@dovydaskukalis/shared/types/api/workspaces/responses';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WorkspaceStore {
  workspace: WorkspaceResponse | null;
  profile: ProfileResponse | null;
  setWorkspace: (workspace: WorkspaceResponse) => void;
  setProfile: (profile: ProfileResponse) => void;
  clearWorkspace: () => void;
}

export const useWorkspaceStore = create<WorkspaceStore>()(
  persist(
    (set) => ({
      workspace: null,
      profile: null,

      setWorkspace: (workspace) => {
        set({ workspace });
      },

      setProfile: (profile) => {
        set({ profile });
      },

      clearWorkspace: () => {
        set({ workspace: null, profile: null });
      },
    }),
    {
      name: 'workspace-storage',
    },
  ),
);
